import _extends from "@babel/runtime/helpers/esm/extends";

/* eslint-disable react/destructuring-assignment */

/* eslint-disable react/prop-types */
import classNames from '@jd/jmtd-tools/es/classnames';
import React, { Fragment } from 'react';
import Form from '../Form';
import FormItem from '../FormItem';
import RadioControl from '../RadioControl';
import { getValue } from '../tools/util';
export default function BasicRadioGroup(_ref, _ref2) {
  var data = _ref.data,
      isChecked = _ref.isChecked,
      select = _ref.select,
      withLabel = _ref.withLabel;
  var size = _ref2.size,
      className = _ref2.className,
      alignControlWidth = _ref2.alignControlWidth,
      bordered = _ref2.bordered,
      separator = _ref2.separator,
      _ref2$formProps = _ref2.formProps,
      formProps = _ref2$formProps === void 0 ? {} : _ref2$formProps,
      clstag = _ref2.clstag,
      _ref2$dataComponent = _ref2['data-component-name'],
      componentName = _ref2$dataComponent === void 0 ? 'RadioGroup' : _ref2$dataComponent;

  if (!data) {
    return null;
  }

  function List(list, listLabel) {
    return /*#__PURE__*/React.createElement(FormItem, {
      "data-component-name": componentName,
      label: listLabel
    }, list.map(function (item) {
      var label = item.label,
          value = item.value,
          disabled = item.disabled;
      return /*#__PURE__*/React.createElement(RadioControl, {
        clstag: "".concat(getValue(clstag, item)),
        className: "jmtd-radio-group-item",
        disabled: disabled,
        key: value,
        checked: isChecked(value),
        onChange: function onChange() {
          select(value);
        }
      }, label);
    }));
  }

  return /*#__PURE__*/React.createElement(Form, _extends({
    size: size,
    bordered: bordered,
    className: classNames('jmtd-radio-group', className),
    alignControlWidth: alignControlWidth,
    separator: separator,
    gutter: 0
  }, formProps), withLabel ? data.map(function (_ref3, index) {
    var label = _ref3.label,
        optionsData = _ref3.data;
    return /*#__PURE__*/React.createElement(Fragment, {
      key: index
    }, List(optionsData, label));
  }) : List(data));
}